export const commonValidationMessages = {
  required: "This field is required",
  min0: "",
  min2: "",
  min1: "",
  max24: "",
  max50: "",
  max5: "",
  max7: "",
  max6: "",
  max12: "",
  max200: "",
  maxVal100: "",
  positive: "",
  integer: "",
  before2after2: "",
  before7after2: "",
  before2after1: "",
  before3after2: "",
  before2after10: "",
  before5after2: "",
  before5after3: "",
  before4after1: "",
  before1after3: "",
  before3after3: "",
  before3after1: "",
  before4after2: "",
  before5after4: "",
  before2after4: "",
  minDateLastRecord: "",
  maxDateCurrentRecord: "",
};

export const DraftsDisplacementValidationMessages = {
  displacement: "",
};

export const WeatherDataValidationMessages = {
  wind_direction: "",
  gyro_course: "",
};

export const SludgeBilgeWaterMessages = {
  tank_number: "",
};

export const VesselGenInfoMessages = {
  short_name: "",
  call_sign: "",
  official_number: "",
  hull_number: "",
  dead_weight: "",
};
